import { FunctionComponent, useMemo } from 'react'
import { DropdownItem, Icon } from '../../shared'
import { ContactOptionProps } from './ContactOption.model'
import { getV3ColorCssVariable } from '../../../design-system/colors_v3'
import classNames from 'classnames'
import styles from './ContactOption.module.scss'

export const ContactOption: FunctionComponent<ContactOptionProps> = ({
  contact,
  selected = false,
  trusted,
  mssEmailAddress,
}) => {
  const organizationAddresses = useMemo(
    () =>
      contact.organizations.map(({ address }) => {
        if (!address) {
          return null
        }

        const { zipCode, city } = address
        return (zipCode && city && `${zipCode} - ${city}`) || city || zipCode
      }),
    [contact],
  )

  const { profession, speciality } = contact
  const subtitle: string | null =
    (speciality && profession && `${profession.description} ${speciality.description}`) ||
    speciality?.description ||
    profession?.description ||
    null

  return (
    <DropdownItem selected={selected}>
      <div className={styles.contactOptionContainer}>
        <div className={styles.contactOptionInfos}>
          {trusted && (
            <Icon size="nano" icon="star" color={getV3ColorCssVariable('primary', 'default')} />
          )}
          <span>
            {contact.firstName} {contact.familyName}
          </span>
          {mssEmailAddress && (
            <span
              className={classNames(styles.contactOptionEmailAddress, {
                [styles.selected]: selected,
              })}
            >{`<${mssEmailAddress}>`}</span>
          )}
        </div>
        {subtitle !== null && (
          <div
            className={classNames(styles.contactOptionSubTitle, { [styles.selected]: selected })}
          >
            {subtitle}
          </div>
        )}
        {organizationAddresses.length > 0 && (
          <div
            className={classNames(styles.contactOptionOrganisationAddresses, {
              [styles.selected]: selected,
            })}
          >
            {organizationAddresses.join(' - ')}
          </div>
        )}
      </div>
    </DropdownItem>
  )
}
